import React from "react";
import { Card, Flex, Result, Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import TelegramButton from "../Settings/TelegramButton";
import useUser from "../../hooks/useUser";
import useOrg from "../../hooks/apis/useOrg";
import Loading from "../../components/loading";
import Error from "../../components/error";
import { IS_WHITE_LABEL } from "../../constants";

const { Title, Paragraph } = Typography;

// Standalone landing page behind the app's auth gate. A logged-out visitor is
// shown <Login/> by the Panel shell and, after login, is navigated back here via
// sessionStorage['post_login_redirect'] — so a shared link connects the account
// even when the recipient wasn't signed in.
function ConnectTelegram() {
  const { data, isLoading, error } = useUser();
  const { data: org } = useOrg();
  const botName = org?.config?.telegramSupportUsername;

  if (error)
    return (
      <Error
        size="fill"
        iconClassName="text-[red]"
        textClassName="text-[red] mt-2 text-2xl"
        text="خطایی رخ داده است"
      />
    );
  if (isLoading) return <Loading size="fill" text="در حال بارگذاری..." />;

  if (IS_WHITE_LABEL || !botName)
    return (
      <Flex justify="center" align="center" style={{ minHeight: "60vh", padding: 16 }}>
        <Result
          status="info"
          title="اتصال تلگرام در دسترس نیست"
          subTitle="در حال حاضر امکان اتصال اکانت تلگرام وجود ندارد."
        />
      </Flex>
    );

  const isLinked = Boolean(data?.telegramId);

  return (
    <Flex justify="center" align="center" style={{ minHeight: "60vh", padding: 16 }}>
      <Card style={{ maxWidth: 420, width: "100%", textAlign: "center" }}>
        <Flex vertical align="center" gap={16}>
          {isLinked ? (
            <>
              <CheckCircleFilled style={{ fontSize: 40, color: "#52c41a" }} />
              <Title level={4} style={{ margin: 0 }}>
                تلگرام شما متصل است
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                اکانت تلگرام شما با موفقیت به حساب کاربری‌تان متصل شده است.
              </Paragraph>
            </>
          ) : (
            <>
              <Title level={4} style={{ margin: 0 }}>
                اتصال اکانت تلگرام
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                با کلیک روی دکمه زیر به بات تلگرام منتقل می‌شوید و اکانت تلگرام شما به
                حساب کاربری‌تان متصل می‌شود.
              </Paragraph>
            </>
          )}
          <TelegramButton data={data} />
        </Flex>
      </Card>
    </Flex>
  );
}

export default ConnectTelegram;
